import React, { useEffect, useRef, useState } from "react";

/** Subtle fade-up on scroll. Wraps any block. */
export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => setShow(true), delay);
        io.disconnect();
      }
    }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);
  return (
    <div ref={ref} className={`fade-in ${show ? "in" : ""} ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
